import React, { useContext, useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../navigation/TemporaryUserInfo';
import styled from 'styled-components';

export const Login = () => {
  const navigate = useNavigate();
  const [id, setId] = useState('');
  const [password, setPassword] = useState('');
  const [errorBorder, setErrorBorder] = useState(true);
  const [errorMessage, setErrorMessage] = useState('');
  const oAuthContext = useContext(AuthContext);

  const onIdChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setId(e.target.value);
  };

  const onPwChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setPassword(e.target.value);
  };

  const onSubmit = async () => {
    if (!id || !password || id === '' || password === '') {
      setErrorMessage('올바른 계정정보를 입력해 주세요.');
      setErrorBorder(false);
      return;
    }

    try {
      let oRes = await oAuthContext.login(id, password);

      if (!oRes) {
        console.log('틀림');
        setErrorMessage('올바른 계정정보를 입력해 주세요.');
        setErrorBorder(false);
        return false;
      } else {
        navigate('/dashboard');
      }
    } catch (error) {
      console.log('서버 에러가 발생했습니다. 다시 시도해 주세요.');
      setErrorBorder(false);
    }
  };

  // enter로 로그인
  const handleEnterKey = useCallback(
    (event: React.KeyboardEvent<HTMLInputElement>) => {
      if (event.key === 'Enter') {
        onSubmit();
      }
    },
    [onSubmit],
  );

  return (
    <Style>
      <div className="wrap">
        <div className="container">
          <div className="loginWrap">
            <div>
              <h1 className="logo">INVISIBLEIDEAS</h1>
              <h1 className="title">로그인 하기</h1>
              <div className="loginForm">
                <label htmlFor="id">아이디</label>
                <input
                  type="text"
                  name="id"
                  placeholder="아이디를 입력해 주세요."
                  value={id}
                  onChange={onIdChange}
                  style={{ border: !errorBorder ? '1px solid red' : '' }}
                />
                {!errorBorder && (
                  <div className="errorMessage">
                    <p>{errorMessage}</p>
                  </div>
                )}
              </div>
              <div className="loginForm">
                <label htmlFor="password">비밀번호</label>
                <input
                  type="password"
                  name="password"
                  placeholder="비밀번호를 입력해 주세요."
                  value={password}
                  onChange={onPwChange}
                  style={{ border: !errorBorder ? '1px solid red' : '' }}
                  onKeyDown={handleEnterKey}
                />
                {!errorBorder && (
                  <div className="errorMessage">
                    <p>{errorMessage}</p>
                  </div>
                )}
              </div>
            </div>
            <button className="loginButton" onClick={onSubmit}>
              <p>로그인 하기</p>
            </button>
          </div>
          
        </div>
      </div>
    </Style>
  );
};

export const Style = styled.div`
  .wrap {
    width: 100%;
    height: 100vh;
    background: #f8fafc;
    display: flex;
    align-items: center;
  }
  .container {
    width: 100%;
    max-width: 480px;
    margin: 0 auto;
    height: 60vh;
    padding: 48px !important;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    border-radius: 8px;
  }
  h1 {
    font-size: 24px;
    font-weight: 600;
    color: #26282c;
  }
  button,
  label,
  label > input {
    cursor: pointer;
  }

  .logo {
    font-weight: 700;
  }
  .title {
    margin-top: 56px;
    margin-bottom: 32px;
  }
  .loginWrap {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  .loginForm {
    display: flex;
    flex-direction: column;
    margin-bottom: 20px;

    label {
      margin-bottom: 6px;
      font-size: 14px;
      font-weight: 500;
      color: #4f5459;
    }
    input {
      padding: 10px 14px;
      border: 1px solid #d0d5dd;
      border-radius: 8px;
      outline: none;
    }
  }
  .formCheckbox {
    width: 100%;
    display: flex;
    justify-content: space-between;

    label {
      display: flex;
      font-size: 16px;
      font-weight: 600;
      align-items: center;
      color: #344054;
    }
    input {
      width: 20px;
      height: 20px;
      margin-right: 12px;
    }
  }
  .loginFind {
    button {
      margin-left: 16px;
      padding: 0;
      border: none;
      background: none;
      outline: none;

      p {
        font-size: 14px;
        font-weight: 400;
        color: #72727e;
      }
    }
  }

  /* errorMessage */
  .errorMessage {
    width: 100%;

    p {
      margin: 6px 0 0 0;
      font-size: 14px;
      font-weight: 400;
      color: #f04438;
    }
  }

  /* 로그인 버튼 */
  .loginButton {
    width: 100%;
    margin-top: auto;
    margin: 12px 0 0 0;
    background: #26282c;
    border-radius: 8px;
    border: none;
    outline: none;

    p {
      font-size: 18px;
      font-weight: 600;
      color: #fff;
    }
  }

  
`;
